import React from "react";
import { Link } from "react-router-dom";

const Section = () => {
  return (
    <section className="ht-hero" id="home">
      <div className="ht-hero-grid">
        {/* Left — Copy */}
        <div className="ht-hero-left">
          <div className="ht-hero-eyebrow">
            <span className="ht-hero-eyebrow-dot" />
            Now with 19 integrations
          </div>

          <h1 className="ht-hero-title">
            Turn feedback into your next{" "}
            <span className="ht-gradient-text">breakthrough</span>
          </h1>

          <p className="ht-hero-desc">
            Collect bug reports, feature requests, and ideas from your customers.
            Prioritize what matters. Ship what they actually want.
          </p>

          <div className="ht-hero-actions">
            <a
              href="https://app.publicbacklog.com/user/login"
              className="ht-btn-primary"
            >
              Start free
              <span style={{ fontSize: "1.1em" }}>&rarr;</span>
            </a>
            <a href="#services" className="ht-btn-secondary">
              See how it works
            </a>
          </div>
        </div>

        {/* Right — Floating Dashboard */}
        <div className="ht-hero-visual">
          <div className="ht-dashboard-card">
            <div className="ht-dashboard-header">
              <div className="ht-dashboard-dot" style={{ background: "#ff5f56" }} />
              <div className="ht-dashboard-dot" style={{ background: "#ffbd2e" }} />
              <div className="ht-dashboard-dot" style={{ background: "#27c93f" }} />
              <span
                style={{
                  marginLeft: "auto",
                  fontSize: "0.7rem",
                  color: "#8585a6",
                  letterSpacing: "0.05em",
                }}
              >
                publicbacklog.com
              </span>
            </div>

            <div className="ht-dashboard-body">
              <div className="ht-mini-kanban">
                {/* New Column */}
                <div className="ht-kanban-col">
                  <div
                    className="ht-kanban-col-title"
                    style={{ borderColor: "#4f46e5" }}
                  >
                    New
                  </div>
                  <div className="ht-kanban-card">
                    <div className="ht-kanban-card-title">Dark mode support</div>
                    <div className="ht-kanban-card-meta">
                      <span
                        className="ht-kanban-tag"
                        style={{
                          background: "rgba(99, 102, 241, 0.15)",
                          color: "#a5b4fc",
                        }}
                      >
                        Request
                      </span>
                      <span className="ht-kanban-votes">&uarr; 24</span>
                    </div>
                  </div>
                  <div className="ht-kanban-card">
                    <div className="ht-kanban-card-title">CSV export broken</div>
                    <div className="ht-kanban-card-meta">
                      <span
                        className="ht-kanban-tag"
                        style={{
                          background: "rgba(239, 68, 68, 0.15)",
                          color: "#fca5a5",
                        }}
                      >
                        Bug
                      </span>
                      <span className="ht-kanban-votes">&uarr; 8</span>
                    </div>
                  </div>
                </div>

                {/* In Progress Column */}
                <div className="ht-kanban-col">
                  <div
                    className="ht-kanban-col-title"
                    style={{ borderColor: "#6366f1" }}
                  >
                    In Progress
                  </div>
                  <div className="ht-kanban-card">
                    <div className="ht-kanban-card-title">Slack integration</div>
                    <div className="ht-kanban-card-meta">
                      <span
                        className="ht-kanban-tag"
                        style={{
                          background: "rgba(99, 102, 241, 0.15)",
                          color: "#a5b4fc",
                        }}
                      >
                        Request
                      </span>
                      <span className="ht-kanban-votes">&uarr; 41</span>
                    </div>
                  </div>
                </div>

                {/* Done Column */}
                <div className="ht-kanban-col">
                  <div
                    className="ht-kanban-col-title"
                    style={{ borderColor: "#818cf8" }}
                  >
                    Done
                  </div>
                  <div className="ht-kanban-card">
                    <div className="ht-kanban-card-title">SSO login</div>
                    <div className="ht-kanban-card-meta">
                      <span
                        className="ht-kanban-tag"
                        style={{
                          background: "rgba(129, 140, 248, 0.15)",
                          color: "#c7d2fe",
                        }}
                      >
                        Idea
                      </span>
                      <span className="ht-kanban-votes">&uarr; 67</span>
                    </div>
                  </div>
                  <div className="ht-kanban-card">
                    <div className="ht-kanban-card-title">API rate limits</div>
                    <div className="ht-kanban-card-meta">
                      <span
                        className="ht-kanban-tag"
                        style={{
                          background: "rgba(239, 68, 68, 0.15)",
                          color: "#fca5a5",
                        }}
                      >
                        Bug
                      </span>
                      <span className="ht-kanban-votes">&uarr; 12</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Stats Strip */}
            <div className="ht-dashboard-stats">
              <div className="ht-dashboard-stat">
                <div className="ht-dashboard-stat-value">1,247</div>
                <div className="ht-dashboard-stat-label">Tickets</div>
              </div>
              <div className="ht-dashboard-stat">
                <div className="ht-dashboard-stat-value">89%</div>
                <div className="ht-dashboard-stat-label">Resolved</div>
              </div>
              <div className="ht-dashboard-stat">
                <div className="ht-dashboard-stat-value">342</div>
                <div className="ht-dashboard-stat-label">Voters</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Section;
